<markant-platform-ui-card
  [headline]="'cartridge.management.usageInformation.title' | transloco"
>
  <p class="actions-section-text">
    {{
      'cartridge.management.usageInformation.info'
        | transloco: { service: variantName }
    }}
  </p>
  <div footer>
    <a class="link" [routerLink]="link">
      {{ 'common.details' | transloco }}
      <markant-icon class="link-icon" icon="m_arrow-right-small"></markant-icon>
    </a>
  </div>
</markant-platform-ui-card>
